import { Link } from 'react-router-dom'
import { notificationsApi } from '../../api/notifications'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum } from './WidgetBody'

/** Il numero di notifiche non lette. */
export function NotificationsUnreadWidget(props: WidgetProps) {
  void props
  const state = useWidgetData(() => notificationsApi.unreadCount(), 'notif')
  return (
    <WidgetBody state={state}>
      {c => (
        <>
          <div className="md-mini-stats">
            <Stat label="Non lette" value={formatNum(c.count)} />
          </div>
          <Link to="/notifications" className="md-typescale-body-small d-inline-block mt-2">
            Apri le notifiche
          </Link>
        </>
      )}
    </WidgetBody>
  )
}
